import { FormattedNumericInput } from '@pinwheel/origami';
import React, { useContext, useEffect } from 'react';
import { useOpts } from '../../../context';
import { fullSwitchAndMoreContext } from './context';
import { useGetLocalizedString } from '../../../hooks/useGetLocalizedString';
function PercentageInput() {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), loadedPlatform = _a.loadedPlatform, selectedEmployer = _a.selectedEmployer, amountSelection = _a.amountSelection, setAmountSelection = _a.setAmountSelection;
    var _b = useContext(fullSwitchAndMoreContext), error = _b.error, setError = _b.setError;
    var value = amountSelection.allocation.value;
    useEffect(function () {
        if (!value)
            return;
        var min = (selectedEmployer === null || selectedEmployer === void 0 ? void 0 : selectedEmployer.minPercentage) || (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.minPercentage) || 1;
        var max = (selectedEmployer === null || selectedEmployer === void 0 ? void 0 : selectedEmployer.maxPercentage) || (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.maxPercentage) || 99;
        if (value >= min && value <= max)
            setError(null);
        else
            setError(getLocalizedString('ERROR_PERCENTAGE_BETWEEN_LIMITS', [
                "".concat(min),
                "".concat(max),
            ]));
    }, [getLocalizedString, loadedPlatform, selectedEmployer, setError, value]);
    return (React.createElement(FormattedNumericInput, { autoFocus: true, value: String(value), "aria-label": "Percentage", "data-testid": "PercentageInput", onChange: function (v) {
            return setAmountSelection({
                action: 'partial_switch',
                allocation: { type: 'percentage', value: v ? +v : null },
            });
        }, maxAmount: 999, minAmount: 1, decimalScale: 0, allowNegative: false, placeholder: "0%", suffix: "%", error: error, required: true }));
}
export default PercentageInput;
